import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";

const TranslationSettings = ({ domain, selectedDomain, setDomain, glossaries, selectedGlossary, setGlossary, handleToggle, checked = false }) => {
    return (
        <Formik
            initialValues={{ domain: "", glossaries: selectedGlossary }}
        >
            {() => (
                <Form className="d-flex flex-column p-4 gap-5">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <label htmlFor="domain">
                            Select Domain
                        </label>
                        <Field
                            as="select"
                            id="domain"
                            name="domain"
                            className="input-field"
                            style={{ width: "25rem" }}
                            value={selectedDomain}
                            onChange={(e) => setDomain(e.target.value)}
                        >
                            <option value="">Select domain</option>
                            {domain.map((domainName) => (
                                <option key={domainName.value} value={domainName.value}>
                                    {domainName.label}
                                </option>
                            ))}
                        </Field>
                    </div>
                    <ErrorMessage
                        name="domain"
                        component="div"
                        className="text-danger mt-1 fs_12"
                    />

                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <label htmlFor="glossaries" >
                            Select Glossaries
                        </label>
                        <Field
                            as="select"
                            id="glossaries"
                            name="glossaries"
                            className="input-field"
                            value={selectedGlossary}
                            style={{ width: "25rem" }}
                            onChange={(e) => setGlossary(e.target.value)}
                        >
                            <option value="">Select glossaries</option>
                            {glossaries.map((glossary) => (
                                <option key={glossary.name} value={glossary.name}>
                                    {glossary.name} {glossary.source_name && `(${glossary.source_name})`}
                                </option>
                            ))}
                        </Field>
                    </div>
                    <div className="d-flex gap-4 justify-content-start align-items-center mt- w-fit">
                        <label htmlFor="confidence" >
                            Confidence Score
                        </label>
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className={`custom-toggle ${checked ? "on" : "off"}`}
                                onClick={handleToggle}
                                role="button"
                                aria-pressed={checked}
                            >
                                <div className="toggle-knob" />
                            </div>
                            {/* <span >{checked ? "ON" : "OFF"}</span> */}
                        </div>

                    </div>
                    <ErrorMessage
                        name="glossaries"
                        component="div"
                        className="text-danger mt-1 fs_12"
                    />
                </Form>
            )}
        </Formik>
    );
};

export default TranslationSettings;
